import Config from '../Config';
import { RestService } from './RestService';

export const UnitService = {
    getUnits: async function(organisation){
        return RestService.get(`${Config.get_units}organisation=${organisation}`, {})
        .then(response => response.json());
    },
};